export default __webpack_public_path__ + "fonts/Karla-Bold.ttf";